<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0; height: 100%">
        <van-cell-group>
            <van-form @submit="onSubmit">
                <van-field
                        v-model="formData.id_code"
                        name="身份证号"
                        label="身份证号"
                        clearable
                        placeholder="请输入身份证号"
                        :rules="[{ required: true, message: '身份证号' }]"
                />
                <van-field
                        v-model="formData.name"
                        name="姓名"
                        label="姓名"
                        clearable
                        placeholder="请输入姓名"
                        :rules="[{ required: true, message: '姓名' }]"
                />
                <div style="padding: 16px;">
                    <van-button round block type="info" native-type="submit" v-if="!saveLoading">
                        登陆
                    </van-button>
                    <van-button round block type="info" v-else :loading="true" loading-text="登陆中...">
                        登陆中...
                    </van-button>
                </div>
            </van-form>
        </van-cell-group>
        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button {
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }

    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import validator from "../../../utils/validator";
    import LoginDialog from '@/components/LoginDialog.vue';

    import {
        Cell,
        Field,
        Tag,
        Stepper,
        Switch,
        Form,
        Toast,
        Button
    } from 'vant';

    Vue.use(Cell).use(Tag).use(Stepper).use(Field).use(Form).use(Switch).use(Button).use(Toast);

    export default {
        name: 'CommonLogin',
        components: {
            LoginDialog
        },
        data: function () {
            return {
                validator,
                saveLoading: false,
                loginShow: false,
                formData: {
                    id: 0,
                    id_code: '',
                    name: '',
                    type: 'time', //时间裁判
                },

                socket: '',
                timer: '',
                heartTimer: '',
                lockReconnect: false,
                timeoutObj: null,
                serverTimeoutObj: null,
            }
        },
        filters: {},
        mounted() {
            let that = this;
        },
        watch: {},
        destroyed() {
            // 销毁监听
        },
        methods: {

            onSubmit() {
                let that = this
                that.saveLoading = true
                that.$api.post('/api/dscore/caipanLogin', that.formData, (res) => {

                    localStorage.setItem('_id_num', res.data.num);
                    rbLink({
                        name: 'TimeScore'
                    });
                    Toast('登陆成功')
                    that.saveLoading = false

                }, (res) => {
                    that.saveLoading = false
                    Toast(res.msg)
                })
            },

            loginSuccess(res) {
                console.log('-------登录成功--------', res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel() {
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },

        }
    }
</script>



// WEBPACK FOOTER //
// TimeLogin.vue?1d3627ac